export const DRIVER_STATUS = [
  {
    value: 0,
    label: 'Inactive'
  },
  {
    value: 1,
    label: 'Active'
  },
  {
    value: 2,
    label: 'Busy'
  }
];

// RESTRICTION_TYPES are the blocks the fraud check and an admin can apply.
//
// There is no separate payments block: locking the account already stops a
// driver charging, because the API runs the same access check on every request.
export const RESTRICTION_TYPES = [
  {
    value: 'payouts',
    label: 'Payouts',
    hint: 'Stripe payout schedule switches to manual, so earnings are held'
  },
  {
    value: 'account',
    label: 'Account (sign-in)',
    hint: 'Driver cannot sign in or take payments, and is emailed a suspension notice'
  }
];
